import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import { Menu } from "antd";
import theme from "@theme";

const globalStyles = css`
  .ant-dropdown .ant-dropdown-menu {
    padding: 10px;
    list-style-type: none;
    background-color: #ffffff;
    background-clip: padding-box;
    border-radius: 5px;

    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
    clear: both;
    margin: 1px;
    padding: 7px 12px;
    color: rgba(0, 0, 0, 0.88);
    font-weight: normal;
    font-size: 14px;
    line-height: 1.8;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border-radius: 3px;
    margin: 1px;
    width: 200px;
  }
`;

const menuItemStyles = css`
  .menu-item {
    transition: transform 0.3s ease;
  }
  .menu-item:hover {
    transform: scale(1.05);
  }
`;

const StyledMenu = styled(Menu)`
  max-height: 350px;
  overflow-y: auto;
  text-align: center;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
  MenuItemStyles: <Global styles={menuItemStyles} />,
  StyledMenu,
};

export default SC;
